<template>
  <ul class="nav nav-mobile-menu">

    <!-- <li class="nav-item">
      <a class="nav-link" href="#pablo">
        <span class="no-icon">Perfil</span>
      </a>
    </li> -->
    <li class="nav-item">
      <a class="nav-link" href="#pablo">
        <span class="no-icon">Cerrar sesión</span>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'mobile-menu'
}
</script>
<style></style>
